import React from 'react';
import { RouterProvider } from 'react-router-dom';
import router from 'router/router';
import { Notifications } from 'components/Notifications/Notifications';

const App: React.FC = () => {
  return (
    <>
      <Notifications />
      <RouterProvider router={router} />
    </>
  );
};

export default App;
